import { render, staticRenderFns } from "./VTags.vue?vue&type=template&id=3bb6a109&scoped=true"
import script from "./VTags.vue?vue&type=script&lang=js"
export * from "./VTags.vue?vue&type=script&lang=js"
import style0 from "./VTags.vue?vue&type=style&index=0&id=3bb6a109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6a109",
  null
  
)

export default component.exports